import PropTypes from "prop-types";
import { Box, Button, Typography } from "@mui/material";
import { Add, Refresh, Router } from "@mui/icons-material";
export default function TableHeader({
  title,
  loading,
  onRefresh,
  onCreateClick,
  creating,
  isTecnicoRedes,
}) {
  return (
    <Box
      sx={{
        p: 2.5,
        bgcolor: "#193e54",
        color: "#fff",
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        flexWrap: "wrap",
      }}
    >
      <Router />
      <Box sx={{ flex: "1 1 260px" }}>
        <Typography component="h1" sx={{ color: "#fff", fontSize: "1.15rem", fontWeight: 700 }}>
          {title}
        </Typography>
        <Typography sx={{ color: "#dbe8f2", fontSize: ".8rem", mt: 0.5 }}>
          Puertos, reinicio automático y últimas operaciones
          {isTecnicoRedes ? " · Creación y edición restringidas" : ""}
        </Typography>
      </Box>
      {!isTecnicoRedes && (
        <Button
          startIcon={<Add />}
          onClick={onCreateClick}
          disabled={loading || creating}
          sx={{ color: "#fff", "&.Mui-disabled": { color: "#a7bbca" } }}
        >
          Crear switch
        </Button>
      )}
      <Button
        startIcon={<Refresh />}
        onClick={onRefresh}
        disabled={loading}
        sx={{ color: "#fff", "&.Mui-disabled": { color: "#a7bbca" } }}
      >
        {loading ? "Procesando…" : "Actualizar"}
      </Button>
    </Box>
  );
}
TableHeader.propTypes = {
  title: PropTypes.string,
  onRefresh: PropTypes.func.isRequired,
  onCreateClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  creating: PropTypes.bool,
  isTecnicoRedes: PropTypes.bool,
};
